import React, { Component } from 'react'

export default class CeiPopup extends Component {
    render() {
        const {visibility, opacity} = this.props.popupProps;

        return (
            <div id="myModal" className="modal" 
                style={{visibility, opacity}}
                onClick={(e)=>{
                    if(e.target.id === "myModal")
                        this.props.resetProps();
                }}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <span className="close" onClick={this.props.resetProps}>&times;</span>
                        <h2>{"CEI 64-8\t" + this.props.img}</h2>
                    </div>
                    <div className="modal-body">
                        <label>{this.props.text}</label>
                        <div className="placing-scheme">
                            <div className="framework">
                                <img src={"./images/cei/" + this.props.img + ".gif"} id="placing-scheme" alt="" loading="eager"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
